// import React from 'react';
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   ListItemAvatar,
//   Avatar,
//   IconButton,
//   Typography,
//   Box,
//   Button,
//   Divider,
//   Paper,
//   Alert
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import CloseIcon from '@mui/icons-material/Close';
// import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
// import { removeFromCart } from '../store/cartSlice';
// import { CartState } from '../types';

// interface CartProps {
//   open: boolean;
//   onClose: () => void;
// }

// const Cart: React.FC<CartProps> = ({ open, onClose }) => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { items, total } = useSelector((state: { cart: CartState }) => state.cart);

//   const handleCheckout = () => {
//     onClose();
//     navigate('/checkout/review');
//   };

//   return (
//     <Drawer
//       anchor="right"
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: {
//           width: { xs: '100%', sm: '500px' },
//           p: 2,
//           display: 'flex',
//           flexDirection: 'column',
//           height: '100%'
//         }
//       }}
//     >
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 8 }}>
//         <Typography variant="h6">
//           Votre Panier
//         </Typography>
//         <IconButton onClick={onClose}>
//           <CloseIcon />
//         </IconButton>
//       </Box>

//       {items.length === 0 ? (
//         <Paper sx={{ p: 4, textAlign: 'center', mt: 4 }}>
//           <Typography variant="h6" gutterBottom>
//             Votre panier est vide
//           </Typography>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={onClose}
//             sx={{ mt: 2 }}
//           >
//             Continuer mes achats
//           </Button>
//         </Paper>
//       ) : (
//         <>
//           {/* Alertes selon les règles de vente */}
//           {(() => {
//             const hasLowPriceItems = items.some(item => item.product.price <= 200);
//             const hasMediumPriceItems = items.some(item => item.product.price > 200 && item.product.price < 1000);

//             return (
//               <>
//                 {hasLowPriceItems && (
//                   <Alert severity="info" sx={{ mb: 2 }}>
//                     <strong>Information :</strong> Les produits ≤ 200 FCFA se vendent par lots de 25 pièces. 
//                     1 lot = 25 pièces, 2 lots = 50 pièces, etc.
//                   </Alert>
//                 )}
//                 {hasMediumPriceItems && (
//                   <Alert severity="info" sx={{ mb: 2 }}>
//                     <strong>Information :</strong> Les produits entre 200 FCFA et 1000 FCFA se vendent par lots de 10 pièces. 
//                     1 lot = 10 pièces, 2 lots = 20 pièces, etc.
//                   </Alert>
//                 )}
//               </>
//             );
//           })()}
          
//           <List sx={{ flexGrow: 1, overflow: 'auto' }}>
//             {items.map((item) => {
//               const price = item.product.price;
//               const quantityLabel =
//                 price <= 200
//                   ? `${price.toLocaleString('fr-FR')} FCFA x ${item.quantity} lot${item.quantity > 1 ? 's' : ''} de 25 pièces`
//                   : price > 200 && price < 1000
//                   ? `${price.toLocaleString('fr-FR')} FCFA x ${item.quantity} lot${item.quantity > 1 ? 's' : ''} de 10 pièces`
//                   : `${price.toLocaleString('fr-FR')} FCFA x ${item.quantity}`;

//               const totalPrice =
//                 price <= 200
//                   ? price * item.quantity * 25
//                   : price > 200 && price < 1000
//                   ? price * item.quantity * 10
//                   : price * item.quantity;

//               return (
//                 <React.Fragment key={item.product._id}>
//                   <ListItem
//                     secondaryAction={
//                       <IconButton
//                         edge="end"
//                         aria-label="delete"
//                         onClick={() => dispatch(removeFromCart(item.product._id))}
//                       >
//                         <DeleteIcon />
//                       </IconButton>
//                     }
//                   >
//                     <ListItemAvatar>
//                       <Avatar
//                         src={item.product.images[0]}
//                         alt={item.product.name}
//                         variant="rounded"
//                         sx={{ width: 56, height: 56, mr: 2 }}
//                       />
//                     </ListItemAvatar>
//                     <ListItemText
//                       primary={item.product.name}
//                       secondary={
//                         <>
//                           <Typography variant="body2" color="text.secondary">
//                             {quantityLabel}
//                           </Typography>
//                           <Typography variant="body2" color="primary">
//                             Total: {totalPrice.toLocaleString('fr-FR')} FCFA
//                           </Typography>
//                         </>
//                       }
//                     />
//                   </ListItem>
//                   <Divider variant="inset" component="li" />
//                 </React.Fragment>
//               );
//             })}
//           </List>

//           <Box sx={{ mt: 'auto', pt: 2 }}>
//             <Typography variant="h6" gutterBottom>
//               Récapitulatif
//             </Typography>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
//               <Typography variant="h6">Total:</Typography>
//               <Typography variant="h6">{total.toLocaleString('fr-FR')} FCFA</Typography>
//             </Box>
//             <Button
//               fullWidth
//               variant="contained"
//               color="primary"
//               onClick={handleCheckout}
//               sx={{ mt: 2 }}
//             >
//               Commander
//             </Button>
//           </Box>
//         </>
//       )}
//     </Drawer>
//   );
// };

// export default Cart;


import React, { useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  IconButton,
  Typography,
  Box,
  Button,
  Divider,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { removeFromCart,incrementQuantity,decrementQuantity } from '../store/cartSlice';
import { CartState } from '../types';
import { getLotSize, formatLotQuantity } from '../utils/lotSize';

interface CartProps {
  open: boolean;
  onClose: () => void;
}

const Cart: React.FC<CartProps> = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { items, total } = useSelector((state: { cart: CartState }) => state.cart);
  const [itemToRemove, setItemToRemove] = useState<string | null>(null);

  const handleCheckout = () => {
    onClose();
    navigate('/checkout/review');
  };

  const confirmRemove = () => {
    if (itemToRemove) {
      dispatch(removeFromCart(itemToRemove));
      setItemToRemove(null);
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: '100%', sm: '420px' },
          p: 2.5,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          backgroundColor: '#faf7f4',
        }
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 1 }}>
        <Typography variant="h5" sx={{ fontFamily: '"Fraunces", Georgia, serif' }}>
          Votre panier
        </Typography>
        <IconButton onClick={onClose} aria-label="Fermer">
          <CloseIcon />
        </IconButton>
      </Box>

      {items.length === 0 ? (
        <Box sx={{ p: 4, textAlign: 'center', mt: 4 }}>
          <Typography variant="h6" gutterBottom sx={{ fontFamily: '"Fraunces", Georgia, serif' }}>
            Votre panier est vide
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            Parcourez le catalogue pour ajouter des pâtes.
          </Typography>
          <Button variant="contained" color="primary" onClick={onClose} sx={{ mt: 1 }}>
            Continuer mes achats
          </Button>
        </Box>
      ) : (
        <>
          {/* Alertes selon les règles de vente */}
          {items.some(item => getLotSize(item.product.price, item.product.lotSize) > 1) && (
            <Alert severity="info" sx={{ mb: 2 }}>
              La quantité correspond au nombre de lots. La taille de chaque lot est indiquée sous l’article.
            </Alert>
          )}

          <List sx={{ flexGrow: 1, overflow: 'auto' }}>
            {items.map(item => {
              const price = item.product.price;

              const qtyRule = getLotSize(price, item.product.lotSize);
              const quantityLabel =
                qtyRule > 1
                  ? `${price} FCFA x ${formatLotQuantity(item.quantity, qtyRule)}`
                  : `${price} FCFA x ${item.quantity}`;

              const totalPrice = price * item.quantity * qtyRule;

              return (
                <React.Fragment key={item.product._id}>
                  <ListItem
                    secondaryAction={
                      <IconButton onClick={() => setItemToRemove(item.product._id)} aria-label="Retirer du panier">
                        <DeleteIcon />
                      </IconButton>
                    }
                  >
                    <ListItemAvatar>
                      <Avatar
                        src={item.product.images[0]}
                        alt={item.product.name}
                        variant="rounded"
                        sx={{ width: 56, height: 56, mr: 2 }}
                      />
                    </ListItemAvatar>

                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <Typography variant="subtitle1">{item.product.name}</Typography>

                          {/* --- BOUTONS + / – --- */}
                          <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
                            <IconButton
                              size="small"
                              onClick={() => dispatch(decrementQuantity(item.product._id))}
                              disabled={item.quantity === 1}
                            >
                              <RemoveIcon />
                            </IconButton>

                            <Typography sx={{ mx: 1, width: 20, textAlign: 'center' }}>
                              {item.quantity}
                            </Typography>

                            <IconButton
                              size="small"
                              onClick={() => dispatch(incrementQuantity(item.product._id))}
                            >
                              <AddIcon />
                            </IconButton>
                          </Box>
                        </Box>
                      }
                      secondary={
                        <>
                          <Typography variant="body2" color="text.secondary">
                            {quantityLabel}
                          </Typography>
                          <Typography variant="body2" color="primary">
                            Total: {totalPrice.toLocaleString('fr-FR')} FCFA
                          </Typography>
                        </>
                      }
                    />
                  </ListItem>

                  <Divider variant="inset" component="li" />
                </React.Fragment>
              );
            })}
          </List>

          <Box sx={{ mt: 'auto', pt: 2, borderTop: '1px solid rgba(26,20,18,0.08)' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <Typography sx={{ fontWeight: 600 }}>Total</Typography>
              <Typography sx={{ fontWeight: 700, color: 'primary.main', fontSize: '1.15rem' }}>
                {total.toLocaleString('fr-FR')} FCFA
              </Typography>
            </Box>

            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              onClick={handleCheckout}
              sx={{ py: 1.4 }}
            >
              Commander
            </Button>
          </Box>
        </>
      )}
      <Dialog open={Boolean(itemToRemove)} onClose={() => setItemToRemove(null)}>
        <DialogTitle>Retirer ce produit du panier ?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Cette action enlèvera le produit de votre panier.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setItemToRemove(null)}>Annuler</Button>
          <Button color="error" onClick={confirmRemove}>
            Retirer
          </Button>
        </DialogActions>
      </Dialog>
    </Drawer>
  );
};

export default Cart;
